export enum TUserRole {
    None = 1,
    Read = 20,
    Write = 40,
    Admin = 90,
    Owner = 100,
}
